import BaseRepository from '@/repositories/base/BaseRepository';

class AdNoticeRepository extends BaseRepository {
  // 消息通知列表
  listFn(params: any) {
    return this.post<any>({
      url: '/ebk-dkb-api/noticeCenter/list',
      data: params,
    });
  }
  //通知详情
  detailFn(params: any) {
    return this.post<any>({
      url: '/ebk-dkb-api/noticeCenter/detail',
      data: params,
    });
  }

  // xlog开关
  getXLogStatus(params: any) {
    return this.get({
      url: '/ebk-dkb-api/switch/xLog',
      data: params,
    });
  }

  // 通知已读
  noticeRead(params: any) {
    return this.post<any>({
      url: '/ebk-dkb-api/noticeCenter/notice-read',
      data: params,
    });
  }

}

export default AdNoticeRepository;
